import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { getActivityInformations } from '@/api/common';
import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { getMisteryGift } from '@/api/mystery';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import BonusView from '@/themes/themeOne/bonus/bonusView.vue';
import BonusViewTwo from '@/themes/themeTwo/bonus/bonusView.vue';
import BonusViewThree from '@/themes/themeThree/bonus/bonusView.vue';
import { BonusData, DayItem, MysteryConfig, RewardData } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusView',
  setup(__props) {

const themeStore = useThemeStore()
// activeStatus -: 0- expired, 1 - active(today), 2-upcoming
const userStore = useUserStore()
const isPopping = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()

const activityInfo = ref([])
const rewardDayList = ref([1, 3, 7, 15, 30])
const rewardDayData = ref<Record<number, RewardData>>({})
const mysteryDataConfig = ref<MysteryConfig>({
    activityIntro: '',
    floatIcon: '',
    extraConfig: {
        reward_day_list: []
    },
    config: {
        resultDTO: {},
        user_join_date: 0,
    },
    startTime: 0
})
const dayList = ref<DayItem[]>([])
const selectedTab = ref<any>({})
const bannerIcon = ref('')

const dataSet = computed<BonusData>(() => ({
    isPopping: isPopping.value,
    activityInfo: activityInfo.value,
    rewardDayList: rewardDayList.value,
    rewardDayData: rewardDayData.value,
    mysteryDataConfig: mysteryDataConfig.value,
    dayList: dayList.value,
    selectedTab: selectedTab.value,
    bannerIcon: bannerIcon.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "MYSTERY_DAY_REWARD"
    }

    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        mysteryDataConfig.value = res.data
        bannerIcon.value = mysteryDataConfig.value?.floatIcon
        activityInfo.value = JSON.parse(mysteryDataConfig.value.activityIntro);
        rewardDayList.value = mysteryDataConfig.value.extraConfig.reward_day_list
        rewardDayData.value = mysteryDataConfig.value.config.resultDTO as Record<number, RewardData>

        dayList.value = rewardDayList.value.map((day: number) => ({
            reward_day: day,
            reward_data: rewardDayData.value[day]
        }))
        selectedTab.value = selectObject(dayList.value)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const pickMisteryGift = (activeStatus: number) => {
     loadingRef.value.open()
    let data = {
        uid: userStore.id
    }
    if (activeStatus == 1) {
        isPopping.value = true
        getMisteryGift(data).then(res => {
            if (res.data.code == 'system.success') {
                loadingRef.value.close()
                showSuccess('')
                getActivityInfo()
            } else {
                showError(res.data.code)
            }
        }).catch(err => {
            showError(err);
            loadingRef.value.close()
        })
    }
}

const selectTab = (item: any) => {
    selectedTab.value = item
}

function selectObject(arr: any) {
    if (!arr.length) return undefined

    // 1. Find object with activeStatus = 1
    const activeOne = arr.find((obj: any) => obj.reward_data.activeStatus === 1)
    if (activeOne) return activeOne

    // 2. Find last object with activeStatus = 0
    const activeZero = [...arr].reverse().find(obj => obj.reward_data.activeStatus === 0)
    if (activeZero) return activeZero

    // 3. Default to first object
    return arr[0]
}
onMounted(() => {
    getActivityInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BonusView, {
            "data-set": dataSet.value,
            onPickMisteryGift: pickMisteryGift,
            onSelectTab: selectTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BonusViewTwo, {
            "data-set": dataSet.value,
            onPickMisteryGift: pickMisteryGift,
            onSelectTab: selectTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(BonusViewThree, {
            "data-set": dataSet.value,
            onPickMisteryGift: pickMisteryGift,
            onSelectTab: selectTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})